import React from 'react'
import { getAssetUrl } from '../../helper/BaseUrl'

export default function DynamicPageDesign({data}) {
      if (!data?.title) return null;
      const sectionImageUrl = getAssetUrl(data?.first_section_image);
  return (
    <>
      <section className="industry-design-area">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-10">
              <h2 className="heading center-heading">{data?.first_section_title}</h2>
            </div>
            <div className="col-lg-7 col-md-6 wow animate__animated animate__fadeInLeft" data-wow-duration="0.8s" data-wow-delay="0.1s">
              <div className="industry-design-img">
                 {sectionImageUrl && <img src={sectionImageUrl} alt={data?.first_section_image_alt || data?.first_section_title || "Section"} />}
              </div>
            </div>

            <div className="col-lg-5 col-md-6 wow animate__animated animate__fadeInRight" data-wow-duration="0.8s" data-wow-delay="0.1s">
              <div className="industry-design-content">            
              <div dangerouslySetInnerHTML={{ __html: data?.first_section_description }} />
                {/* <ul>
                  {data?.list.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
